import {
  compose as lcompose,
  prop as lprop,
  isEmpty as lisEmpty,
  anyPass,
} from 'lodash/fp';

const missingComments = lcompose(lisEmpty, lprop('request.comments'));
const missingSelectedUserRoleKeys = lcompose(
  lisEmpty,
  lprop('selectedUserRoleKeys')
);

export const disableSubmit = anyPass([
  missingComments,
  missingSelectedUserRoleKeys,
]);
